import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';

import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";


Vue.config.productionTip = false;

var firebaseConfig = {
  apiKey: "AIzaSyC9xl_G5kZ4cKne1enoeVLwFHzy1_gQqUk",
  authDomain: "moramyun-7cc8f.firebaseapp.com",
  databaseURL: "https://moramyun-7cc8f.firebaseio.com",
  projectId: "moramyun-7cc8f",
  storageBucket: "moramyun-7cc8f.appspot.com",
  messagingSenderId: "533616380850",
  appId: "1:533616380850:web:4d861bcf7cd1cfb4e2f2ab",
  measurementId: "G-PL0R04HKEC"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");


